/**
 * Formats Auto DoB from `2001-01-17` to `2001-01-17T12:00:00.000Z`
 *
 * @param dob Optional, string representing date of birth
 * @returns Returns date of birth formated in date time, if param was valid
 */
function formatAutoDoB(dob) {
    if (!dob)
        return "";
    return `${dob}T12:00:00.000Z`;
}
/**
 * Formats Auto email to the array format and gives it a type of 'PRIMARY'
 *
 * @param email Optional, string representing an email
 * @returns Returns an array of customer email
 */
function formatAutoEmail(email) {
    if (!email)
        return [];
    return [
        {
            type: "PRIMARY",
            value: email,
        },
    ];
}
/**
 * This takes in the AFG Customer domain and normalizes it data such that
 * auto properties (like, name, email, phone, dob, address, etc.) are
 * hoisted to the top-level and formatted correctly.
 *
 * @param response Customer domain used to get data and errors
 * @returns Returns a customer domain with normalized data
 */
export function normalizeData(response) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    const { data, errors } = response;
    return {
        data: !data
            ? data
            : Object.assign(Object.assign({}, data), { id: (_a = data.id) !== null && _a !== void 0 ? _a : (_b = data.auto) === null || _b === void 0 ? void 0 : _b.tpn, name: Object.assign(Object.assign({}, data.name), { first: (_d = (_c = data.name) === null || _c === void 0 ? void 0 : _c.first) !== null && _d !== void 0 ? _d : (_e = data.auto) === null || _e === void 0 ? void 0 : _e.firstName, 
                    // Always use top-level unless undefined
                    middle: ((_f = data.name) === null || _f === void 0 ? void 0 : _f.middle) !== undefined
                        ? data.name.middle
                        : (_g = data.auto) === null || _g === void 0 ? void 0 : _g.middleName, last: (_j = (_h = data.name) === null || _h === void 0 ? void 0 : _h.last) !== null && _j !== void 0 ? _j : (_k = data.auto) === null || _k === void 0 ? void 0 : _k.lastName }), dob: (_l = data.dob) !== null && _l !== void 0 ? _l : formatAutoDoB((_m = data.auto) === null || _m === void 0 ? void 0 : _m.dob), status: (_o = data.status) !== null && _o !== void 0 ? _o : (_p = data.auto) === null || _p === void 0 ? void 0 : _p.customerStatus, phones: (_s = (_q = data.phones) !== null && _q !== void 0 ? _q : (_r = data.auto) === null || _r === void 0 ? void 0 : _r.phones) !== null && _s !== void 0 ? _s : [], emails: (_t = data.emails) !== null && _t !== void 0 ? _t : formatAutoEmail((_u = data.auto) === null || _u === void 0 ? void 0 : _u.email), addresses: (_v = data.addresses) !== null && _v !== void 0 ? _v : (data.auto ? [data.auto.address] : []), lobRelationships: (_w = data.lobRelationships) !== null && _w !== void 0 ? _w : [], identifications: (_x = data.identifications) !== null && _x !== void 0 ? _x : [], profileVerification: (_y = data.profileVerification) !== null && _y !== void 0 ? _y : {} }),
        errors,
    };
}
//# sourceMappingURL=index.js.map